import React, { useMemo } from 'react';

import AvatarGroup from '@atlaskit/avatar-group';
import type { AvatarProps } from '@atlaskit/avatar-group';

import type { Agent } from '@atlassian/conversation-assistant-service';

import { renderMoreIndicator } from '../CorePresenceMoreIndicator';

import { AgentPresenceAvatar } from './AgentPresenceAvatar';

const MAX_GROUP_SIZE = 4;

export const renderAgent = (agents: Agent[], count: number) => {
	return (_: any, props: AvatarProps & { agentId?: string }, index: number) => {
		const agent = agents.find((a) => a.id === props.agentId);

		if (!agent) {
			return null;
		}

		return <AgentPresenceAvatar agent={agent} stackIndex={count - index} showBorder {...props} />;
	};
};

export type AgentPresenceAvatarGroupProps = {
	agents: Agent[];
	isOpen: boolean;
	onMoreClick: () => void;
};

export const AgentPresenceAvatarGroup = ({
	agents,
	isOpen,
	onMoreClick,
}: AgentPresenceAvatarGroupProps) => {
	const data: (AvatarProps & { agentId: string })[] = useMemo(() => {
		return agents.map((agent) => ({
			agentId: agent.id,
			name: agent.name,
		}));
	}, [agents]);

	return (
		<AvatarGroup
			testId="agent-presence-avatar-group"
			appearance="stack"
			size="small"
			maxCount={MAX_GROUP_SIZE}
			data={data}
			shouldPopupRenderToParent={false}
			onMoreClick={onMoreClick}
			overrides={{
				Avatar: {
					render: renderAgent(agents, data.length),
				},
				MoreIndicator: {
					render: renderMoreIndicator(isOpen, data.length - MAX_GROUP_SIZE + 1),
				},
			}}
		/>
	);
};
